import { isElementScrolledOutsideView } from '../is-element-scrolled-outside-view';

export function isElementOutsideWindow(element: Element): boolean {
	const overlayRect = element.getBoundingClientRect();

	const parentRects = [
		{
			width: window.innerWidth,
			height: window.innerHeight,
			bottom: window.innerHeight,
			right: window.innerWidth,
			top: 0,
			left: 0,
		},
	];

	return isElementScrolledOutsideView(overlayRect, parentRects);
}
